import { render, staticRenderFns } from "./TooltipAniversarioClubDeGolf.vue?vue&type=template&id=973131c0"
import script from "./TooltipAniversarioClubDeGolf.vue?vue&type=script&lang=js"
export * from "./TooltipAniversarioClubDeGolf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports